
import { defineComponent, markRaw, reactive, toRaw } from 'vue';
interface UserInfo {
    name: string;
    age: number;
    a?: number[];
}
export default defineComponent({
    name: 'App',
    setup() {
        const date1 = reactive<UserInfo>({
            name: 'abc',
            age: 19,
        });
        const changeDate1 = () => {
            const user = toRaw(date1);
            user.name = 'aaaa';
            console.log(user);
        };
        const a = [1,2];
        date1.a = markRaw(a);
        const changeDate2 = () => {
            if (date1.a) {
                date1.a[0] += 2;
            }
            console.log(date1);
        };

        return {
            date1,
            changeDate1,
            changeDate2,
        }
    }
});
